import { Box, Button, Typography } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";
import { BUTTON, ROUTES, UI_TEXT } from "../../constants";
import { useTranslation } from "react-i18next";
import { AuthPageStyles } from "../../utilities/themeColors";
import useBrandingAssets from "../../hooks/useBrandingAssets";
import CompanyLogo from "../../components/CompanyLogo/CompanyLogo";

const AuthedUser = () => {
	const navigate = useNavigate();
	const { authBackdropStyle } = useBrandingAssets();
	const {t} = useTranslation();

	const handleGoToHome = () => {
		navigate(ROUTES.HOME_ALIA);
	};

	const handleLogout = () => {
		navigate(ROUTES.LOGOUT);
	};




	return (
		<Box className="login-container" sx={authBackdropStyle || AuthPageStyles}>
			<Box className="login-form-container">
				<CompanyLogo alt="Logo" className="login-logo" />
				<Box className="authenticated-container">
					<Typography variant="h6" gutterBottom>
						{t('UI_TEXT.YOU_ARE_ALREADY_LOGGED')}
					</Typography>
					<Box display="flex" justifyContent="center" gap={2} mt={2}>
						<Button variant="contained" color="primary" onClick={handleGoToHome}>
							{t('BUTTON.GO_TO_HOME')}
						</Button>
						<Button variant="outlined" color="primary" onClick={handleLogout}>
							{t('BUTTON.LOGOUT')}
						</Button>
					</Box>
				</Box>
			</Box>
		</Box>
	);
};

export default AuthedUser;
